export default __webpack_public_path__ + "images/0xfe4546fefe124f30788c4cc1bb9aa6907a7987f9.png";